import { BasePagedSearchCriteria } from "./BaseSearchCriteria";

export interface DefaultReportTemplateSearchCriteria extends BasePagedSearchCriteria {

    name?: string;
    type?: string;
}

export const DEFAULT_REPORT_TEMPLATE_SEARCH_CRITERIA_KEY = 'DefaultReportTemplateSearchCriteria';
